import React from 'react';
import { Accordion } from 'components/accordion';
import GuidesMobileItem from './guides-mobile-item';
import { GuidesMobileItemProps } from './guides-mobile-item.type';

const UNKNOWN_ITEM = null;

export type GuidesMobileProps = {
    content: GuidesMobileItemProps[];
    activeItem?: number;
};

const GuidesMobile: React.FC<GuidesMobileProps> = ({ content, activeItem = UNKNOWN_ITEM }) => {
    const [activeEventKey, setActiveEventKey] = React.useState(activeItem);
    const onToggleHandler = (index: number | null) => setActiveEventKey(index);
    const onToggle = (event: number) => onToggleHandler(event);
    const onCloseHandler = () => onToggleHandler(UNKNOWN_ITEM);

    // update position for page navigation
    React.useEffect(() => {
        if (activeItem !== activeEventKey) {
            setActiveEventKey(activeItem);
        }
    }, [activeItem, activeEventKey]);

    return (
        <Accordion activeEventKey={activeEventKey} onToggle={onToggle}>
            {content.map((item, index) =>
                item ? (
                    <GuidesMobileItem
                        id={item.id}
                        index={index}
                        activeEventKey={activeEventKey}
                        onCloseHandler={onCloseHandler}
                        key={index}
                        {...item}
                    />
                ) : null
            )}
        </Accordion>
    );
};

export default GuidesMobile;
